import BaseModel from '../base';
import TaskSettings from './settings';
import TaskQuestion from './question';

import constants from './constants';
import glossary from './glossary';
import functions from './functions';

export default class Task extends BaseModel {
  constructor(task, url) {
    super(task, url);

    this.name = task.name || '';
    this.type = task.type || this.constructor.constants.TASK_TYPES.AUTOMATED_TESTING;
    // @format нет, есть только "settings.is_online", как я понял
    this.description = task.description || '';
    this.created_at = task.created_at || new Date();
    this.updated_at = task.updated_at || new Date();

    // this.tournament_stage_group_id = task.tournament_stage_group_id || '';
    this.address_child = task.address_child || '';

    this.settings = new TaskSettings(task.settings || {});

    // expand: 'questions',
    this.questions = (task.questions || []).map((item) => new TaskQuestion(item));

    this.tournament_stage_group = task.tournament_stage_group;
  }

  get displayName() {
    return this.name || 'Без названия';
  }

  get displayType() {
    return this.constructor.glossary.TASK_TYPES_DATA[this.type];
  }

  get displayFormat() {
    const { is_online } = this.settings;
    return this.constructor.glossary.TASK_FORMATS_DATA[+is_online];
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }

  static get functions() {
    return functions;
  }
}
